import { useEffect, useCallback, useMemo } from "react";

type Key = string;
type Keys = Key | Key[];

export function useKeypress(keys: Keys, callback: (event: KeyboardEvent) => void) {
  const keyList = useMemo(() => (Array.isArray(keys) ? keys : [keys]), [keys]);

  const handler = useCallback(
    (event: KeyboardEvent) => {
      if (keyList.includes(event.key)) {
        callback(event);
      }
    },
    [keyList, callback],
  );

  useEffect(() => {
    if (typeof window === "undefined") return;

    window.addEventListener("keydown", handler);

    return () => {
      window.removeEventListener("keydown", handler);
    };
  }, [handler]);
}
